import { u as n } from "../../jsxRuntime.module-Bzuv3cXw.js";
import { c as m, S as i, C as p } from "../../useActions-BIIcXXS6.js";
import { d as s, u as l, S as f } from "../../baseConfig-CTN0CcW-.js";
import { s as C } from "../../index.es-B8mbAxS4.js";
import { B as d } from "../../BaseElement-fZSwbg09.js";
import { useCallback as S } from "preact/hooks";
const g = {
  ...s,
  memoryCache: !1
};
function k(e) {
  return {
    pageType: "autocomplete",
    ...g,
    ...e
  };
}
function I({ config: e, store: t, children: o }) {
  const r = t ?? m();
  return l(), /* @__PURE__ */ n(p, { value: k(e), children: /* @__PURE__ */ n(i, { value: r, children: [
    /* @__PURE__ */ n(f, {}),
    o
  ] }) });
}
function P({
  children: e,
  hit: t,
  as: o,
  componentProps: r
}) {
  const c = S(() => {
    t && "productId" in t && C((a) => a.recordSearchClick("autocomplete", t));
  }, [t]);
  return /* @__PURE__ */ n(d, { onClick: c, as: o, componentProps: r, children: e });
}
function E({ as: e, componentProps: t, onSearchInput: o, children: r }) {
  const c = {
    ...t,
    onInput: (u) => {
      o(u.target);
    }
  }, a = e ?? "input";
  return e || (c.type = "search"), /* @__PURE__ */ n(a, { ...c, children: r });
}
export {
  P as AutocompleteElement,
  I as AutocompletePageProvider,
  E as SearchInput
};
